import { fetch } from 'containers/ClanManagement/proxy/helpers'

export const GLOBAL_MAP_INFO_REQUEST = 'global_map/INFO_REQUEST'
export const GLOBAL_MAP_INFO_SUCCESS = 'global_map/INFO_SUCCESS'
export const GLOBAL_MAP_INFO_ERROR = 'global_map/INFO_ERROR'


export function requestGlobalMapInfo(notResetState) {
    return async (dispatch, getState) => {
        dispatch({
            type: GLOBAL_MAP_INFO_REQUEST,
            payload: { notResetState },
        })

        const { gatewayHost } = getState().settings
        const url = `${gatewayHost}/global_map/wgapi/clan_landing/` // trailing slash is mandatory

        // mock:
        if (process.env.API_ENV === 'mock') {
            return dispatch({
                type: GLOBAL_MAP_INFO_SUCCESS,
                payload: require('../__mocks__/clan_landing_mock').global_map_response.eventWithShop,
            })
        }

        try {
            // TODO: refactor and use vanilla fetch
            const response = await fetch(url, { credentials: 'include' })
            dispatch({
                type: GLOBAL_MAP_INFO_SUCCESS,
                payload: response,
            })
        } catch (e) {
            dispatch({
                type: GLOBAL_MAP_INFO_ERROR,
            })
        }
    }
}



// WEBPACK FOOTER //
// ./state/actions/global_map.js